import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = () => ({
	uploadedFiles: [],
	fileData: {},
	uploadSocket: null,
});

const getters = {
	getFileData: (state) => state.fileData,
	getUploadedFiles: (state) => state.uploadedFiles,
	getUploadSocket: (state) => state.uploadSocket,
};

const mutations = {
	stopSocket(state, index) {
		state.uploadedFiles[index].isCancelled = true;
		console.log(index, "index");
	},
	setUploadSocket(state, socket) {
		state.uploadSocket = socket;
	},
	removeThumbnail(state, index) {
		if (state.uploadedFiles[index]) {
			Vue.set(state.uploadedFiles[index], "assetThumbnail", null);
		}
	},
	REMOVE_COMPLETED_FILE(state, fileIndex) {
		state.uploadedFiles.splice(fileIndex, 1);
	},
	REMOVE_COMPLETED_FILE_USING_TEMP_ID(state, tempId) {
		const index = state.uploadedFiles.findIndex(
			(file) => file.fileData.tempId === tempId
		);
		if (index !== -1) {
			state.uploadedFiles.splice(index, 1);
		}
	},
	clearUploadedFiles(state) {
		state.uploadedFiles = [];
	},
	clearSocket(state) {
		state.uploadSocket = null;
	},
	ADD_UPLOADED_FILE(state, fileData) {
		fileData.progress = 0;
		state.uploadedFiles.push(fileData);
	},
	UPDATE_UPLOAD_PROGRESS(
		state,
		{ tempId, progress, id, timeRemaining, estimatedTimeRemaining }
	) {
		const file = state.uploadedFiles.filter(
			(file) => file.fileData.tempId === tempId
		)[0];
		if (!file) return;
		file.progress = progress;
		file.id = id;
		file.timeRemaining = timeRemaining;
		file.estimatedTimeRemaining = estimatedTimeRemaining;
	},
	GET_FILE_DATA(state, fileData) {
		state.fileData = fileData;
	},
};
const actions = {
	removeThumbnail({ commit }, index) {
		commit("removeThumbnail", index);
	},
	updateUpload(
		{ commit },
		{ tempId, index, progress, id, timeRemaining, estimatedTimeRemaining }
	) {
		commit("UPDATE_UPLOAD_PROGRESS", {
			tempId,
			index,
			progress,
			id,
			timeRemaining,
			estimatedTimeRemaining,
		});
	},

	addUploadedFile({ commit }, videoData) {
		commit("ADD_UPLOADED_FILE", videoData);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
